import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { FuelBottomSheet, FuelDialog, FuelFlex } from '@frete.com/fuel-station-react';
import { useAppContext } from 'hooks/useAppContext';
import { useAmplitude } from 'hooks/useAmplitude';
import { useGlobals } from 'hooks/useGlobals';
import { useNavigate } from 'react-router-dom';
import { dsTheme } from 'constants/styled.contants';
import { getDataByProduct } from './utils';
import * as Styled from './styled';
import { ModalBlockToUpsellProps } from './types';

const ModalBlockToUpSell = ({ toggleModal, isOpen, handleFormModal }: ModalBlockToUpsellProps) => {
  const modalTriggeredSlug = 'freight-register-sharing';
  const navigate = useNavigate();
  const { user, foco: { isFocoNotPremium } = false } = useGlobals();

  const {
    state: {
      deviceSize: { isMobile },
    },
  } = useAppContext();

  const { sendAmplitude } = useAmplitude();

  const handleConfirm = () => {
    toggleModal();
  };

  const handleClose = (source: 'button' | 'overlay' = 'overlay') => {
    const amplitudeData = {
      companyId: user?.data?.company?.id,
      userId: user?.data?.id,
      combo: user?.data?.company?.combo?.name,
    };
    if (source === 'button') {
      if (!!isFocoNotPremium) {
        sendAmplitude('menu_clicked', {
          ...amplitudeData,
          type: 'share_freight_change_plan',
        });
        handleFormModal();
      } else {
        sendAmplitude('menu_clicked', {
          ...amplitudeData,
          type: 'share_freight_change_plan_find_out',
        });
        navigate('/novos-planos');
      }
    }

    toggleModal();
  };

  const refuseText = !!isFocoNotPremium ? 'Mudar de plano' : 'Saiba mais';

  if (isMobile) {
    return (
      <FuelBottomSheet
        height={512}
        isOpen={isOpen}
        onClose={() => handleClose('overlay')}
        onRefuse={() => handleClose('button')}
        onConfirm={handleConfirm}
        portalName="host-block-plan"
        confirmText="Continuar e compartilhar"
        zIndex={7}
        spacingBottom="64px"
        refuseText={refuseText}
        title={getDataByProduct(modalTriggeredSlug)?.title}
      >
        <FuelFlex defaultProps={{ customMargin: `${dsTheme.spacing.km4} 0`, flexDirection: 'column' }}>
          <Styled.WrapperImage>
            <video src={`${getDataByProduct(modalTriggeredSlug)?.video}`} autoPlay muted loop />
          </Styled.WrapperImage>
          <FuelTypography size="body-md" weight="regular" color="neutral-default">
            {getDataByProduct(modalTriggeredSlug)?.subtitle}
          </FuelTypography>
        </FuelFlex>
      </FuelBottomSheet>
    );
  }

  return (
    <FuelDialog.Root
      isOpen={isOpen}
      onClose={() => handleClose('overlay')}
      width="572px"
      portalName="portal-trucker-listing"
    >
      <FuelDialog.Header>
        <FuelTypography size="heading-lg" weight="bold" color="neutral-strong">
          {getDataByProduct(modalTriggeredSlug)?.title}
        </FuelTypography>
      </FuelDialog.Header>
      <FuelDialog.Body>
        <Styled.WrapperImage>
          <video src={`${getDataByProduct(modalTriggeredSlug)?.video}`} autoPlay muted loop />
        </Styled.WrapperImage>
        <FuelTypography size="body-md" weight="regular">
          {getDataByProduct(modalTriggeredSlug)?.subtitle}
        </FuelTypography>
      </FuelDialog.Body>
      <FuelDialog.Footer>
        <FuelDialog.Action variant="tertiary" size="large" onClick={() => handleClose('button')} fullWidth>
          {refuseText}
        </FuelDialog.Action>
        <FuelDialog.Action variant="primary" size="large" onClick={handleConfirm} fullWidth>
          Continuar e compartilhar
        </FuelDialog.Action>
      </FuelDialog.Footer>
    </FuelDialog.Root>
  );
};

export default ModalBlockToUpSell;
